<template>
  <section class="w-full p-4 md:p-6 bg-white shadow-md rounded-md border border-iron">
    <h1 class="mb-6 text-lg font-semibold">{{ translate('Professional information', 'ucfirst') }}</h1>

    <form @submit.prevent="submitForm" class="grid grid-cols-2 gap-x-4 gap-y-6 text-base font-normal">
      <span class="col-span-2 md:col-span-1 p-float-label">
        <InputText v-model.trim="localProfile.professional_firstname" type="text" id="first_name"
          class="w-full px-3 py-2 rounded-full border border-iron" />
        <label for="first_name">{{ translate('first name', 'ucfirst') }}</label>
      </span>

      <span class="col-span-2 md:col-span-1 p-float-label">
        <InputText v-model.trim="localProfile.professional_lastname" type="text" id="last_name"
          class="w-full px-3 py-2 rounded-full border border-iron" />
        <label for="last_name">{{ translate('last name', 'ucfirst') }}</label>
      </span>

      <span class="col-span-2 md:col-span-1 p-float-label">
        <InputText v-model.trim="localProfile.professional_title" type="text" id="title"
          class="w-full px-3 py-2 rounded-full border border-iron" />
        <label for="title">{{ translate('title', 'ucfirst') }}</label>
      </span>

      <span class="col-span-2 md:col-span-1 p-float-label">
        <InputText v-model.trim="localProfile.professional_email" type="email" id="email"
          class="w-full px-3 py-2 rounded-full border border-iron text-oxford-blue font-semibold" />
        <label for="email">{{ translate('email', 'ucfirst') }}</label>
      </span>

      <span class="col-span-2 md:col-span-1 p-float-label">
        <InputMask v-model="localProfile.professional_phone" mask="(99) 99999-9999" inputId="phone"
          class="w-full px-3 py-2 rounded-full border border-iron" />
        <label for="phone">{{ translate('Phone', 'ucfirst') }}</label>
      </span>

      <span class="col-span-2">
        <Button type="submit" :label="translate('save', 'ucfirst')"
          class="py-2 px-4 float-right text-white rounded-md bg-sea-serpent w-full md:w-auto" />
      </span>
    </form>
  </section>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Button from 'primevue/button';

const props = defineProps({
  professionalProfile: Object,
  translate: Function
});

const localProfile = ref({ ...props.professionalProfile });

const emit = defineEmits(['update-profile']);

watch(localProfile, (newValue) => {
  emit('update-profile', newValue);
}, { deep: true });

const submitForm = () => {
  emit('update-profile', localProfile.value);
};
</script>
